import { ProviderCaseStatusGetDTO } from "../../providers/provider.model";
import { isClosed } from "../helpers/isCanceled";
import {
  FiledClaimStatusSumaryUiModel,
  FiledClaimUiModel,
  ProviderClaimKpiStatusBreakdown,
} from "../models/filed-case-ui.model";
import { FiledCaseResponseAPI } from "../models/filed-case.response-api.model";

export function mapFiledCaseResponseToUIModel(
  response: FiledCaseResponseAPI,
  statusApi: ProviderCaseStatusGetDTO[],
): FiledClaimUiModel {
  if (!response || !response.providerBreakdown) {
    return {
      filedClaimProviderBreakdownUIModel: [],
      summary: {
        filedCasesAmount: 0,
        filedCasesTotal: 0,
        cashReimbursementTotal: 0,
        cashReimbursementAmount: 0,
        inventoryReimbursementAmount: 0,
        inventoryReimbursementTotal: 0,
        statusSumary: {},
      },
    };
  }
  const statusSummary: FiledClaimStatusSumaryUiModel = {};

  const filedClaimProviderBreakdownUIModel = Object.entries(
    response.providerBreakdown,
  ).map(([providerName, data]) => {
    const statusBreakdown: ProviderClaimKpiStatusBreakdown[] = Object.entries(
      data.statusBreakdown,
    ).map(([status, statusData]) => {
      const total = statusData.total ?? 0;
      const amount = statusData.amount;
      const cashReimbursementAmount = statusData.cashReimbAmount;
      const inventoryReimbursementAmount = statusData.invReimbAmount;

      if (!statusSummary[status]) {
        statusSummary[status] = {
          total: 0,
          amount: 0,
          isClosed: false,
          cashReimbursementAmount: 0,
          inventoryReimbursementAmount: 0,
        };
      }

      statusSummary[status].total += total;
      statusSummary[status].amount += amount;
      statusSummary[status].cashReimbursementAmount += cashReimbursementAmount;
      statusSummary[status].inventoryReimbursementAmount +=
        inventoryReimbursementAmount;
      statusSummary[status].isClosed = isClosed(status, statusApi);
      return {
        status,
        total,
        amount,
        cashReimbursementAmount,
        inventoryReimbursementAmount,
        isClosed: isClosed(status, statusApi),
      };
    });

    return {
      providerName,
      filedCasesTotal: data.filedCasesTotal,
      filedCasesAmount: data.filedCasesAmount,
      cashReimbursementTotal: data.cashReimbursementTotal,
      cashReimbursementAmount: data.cashReimbursementAmount,
      inventoryReimbursementTotal: data.inventoryReimbursementTotal,
      inventoryReimbursementAmount: data.inventoryReimbursementAmount,
      statusBreakdown,
    };
  });

  return {
    filedClaimProviderBreakdownUIModel,
    summary: {
      filedCasesAmount: Object.values(response.providerBreakdown).reduce(
        (sum, data) => sum + data.filedCasesAmount,
        0,
      ),
      filedCasesTotal: Object.values(response.providerBreakdown).reduce(
        (sum, data) => sum + data.filedCasesTotal,
        0,
      ),
      cashReimbursementTotal: Object.values(response.providerBreakdown).reduce(
        (sum, data) => sum + data.cashReimbursementTotal,
        0,
      ),
      cashReimbursementAmount: Object.values(response.providerBreakdown).reduce(
        (sum, data) => sum + data.cashReimbursementAmount,
        0,
      ),
      inventoryReimbursementAmount: Object.values(
        response.providerBreakdown,
      ).reduce((sum, data) => sum + data.inventoryReimbursementAmount, 0),
      inventoryReimbursementTotal: Object.values(
        response.providerBreakdown,
      ).reduce((sum, data) => sum + data.inventoryReimbursementTotal, 0),
      statusSumary: statusSummary,
    },
  };
}
